import React from "react";
import { MakeLabelParams } from "../../types/MakeLabelParams";
import { ObjectRefLabel } from "./ObjectRefLabel/ObjectRefLabel";

export const makeObjectRefLabel = (data: MakeLabelParams) => (
  <ObjectRefLabel params={data} />
);
